import axios from 'axios';

// Dòng nhắc trên thẻ sản phẩm từng sàn — đọc file tĩnh /img/product-notes.json
// (giống guide-videos.json / utility-blocks.json). Admin sửa ở trang "Dòng nhắc sản
// phẩm" là web đổi ngay, KHÔNG cần build lại.
const STATIC_URL = `${process.env.REACT_APP_API_PUBLIC_URL || ''}/img/product-notes.json`;
const TTL_MS = 5 * 60 * 1000;

let cache = null; // { ts, data }
let inflight = null;

/** Tải map dòng nhắc; lỗi → {} (thiếu chữ quảng cáo không đáng làm hỏng thẻ sản phẩm). */
function fetchNotes() {
    if (cache && Date.now() - cache.ts < TTL_MS) return Promise.resolve(cache.data);
    if (inflight) return inflight;

    // ?t= chống cache HTTP: file tĩnh được nginx trả kèm max-age 7 ngày, không phá cache
    // thì trình duyệt đã tải 1 lần sẽ giữ chữ cũ cả tuần (guide-videos.json cũng làm vậy).
    inflight = axios
        .get(`${STATIC_URL}?t=${Date.now()}`, { timeout: 5000 })
        .then((res) => {
            const data = res.data || {};
            cache = { ts: Date.now(), data };
            inflight = null;
            return data;
        })
        .catch(() => {
            inflight = null; // KHÔNG cache lỗi → lần sau thử lại
            return {};
        });

    return inflight;
}

/** Chữ nhắc của 1 sàn ('' = không hiện gì). */
export async function getProductNote(platform) {
    const notes = await fetchNotes();
    return String(notes[platform] || '').trim();
}

export default { getProductNote };
